import {mapState, mapActions} from 'pinia';
import './roadoptions.css';
import {useRoutingStore} from '../../store.js';

export const RoadOptions = {
    props: {
        // Пропсы компонента
    },

    data() {
        return {
            // Локальные данные компонента
            isLoading: false,
            checkCycle: false
        };
    },
    computed: {
        ...mapState(useRoutingStore, [
            'IsCycle',
            'RLStartPoint'
        ]),
    },


    methods: {
        ...mapActions(useRoutingStore, [
            'setCycle',
            'flip',
        ]),
    },
    watch: {
        // при каждом изменении `question` эта функция будет запускаться
        IsCycle(newIsCycle, oldIsCycle) {
            this.checkCycle = newIsCycle
        }
    },


    mounted() {
    },

    // language=Vue
    template: `
        <div class="ymap-cycle_selector-change">
          <div class="ymap-cycle-change">
            <input type="checkbox" id="checkbox" v-model="checkCycle" :disabled="!RLStartPoint" @change="() => setCycle(checkCycle)" />
            <label for="checkbox" :class="{ 'text-strikethrough': !RLStartPoint }" >Зациклить</label>
          </div>
          <button class="ui-btn ui-btn-primary" style="{height: 2rem}" @click="() => flip()">Отзеркалить</button>
        </div>
    `
};